import React, { useContext } from "react";

import GlobalContext from "@/contexts/Global/GlobalContext";

import { Icon, IconTypeEnum } from "../icon";

import { ExpertBadgeProps } from "./types";
import "./styles.scss";

const ExpertBadge = ({ ExpertBadgeData, className }: ExpertBadgeProps) => {
  const { openBadgeModal } = useContext(GlobalContext);

  const openExpertBadgeInfoModal = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    openBadgeModal();
  };

  switch (ExpertBadgeData) {
    case "New":
      return (
        <div className={`expert-badge expert-badge--new ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Leaves} viewBox={18} viewBoxHeight={16} className="expert-badge__icon-new" />
          New
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Silver":
      return (
        <div className={`expert-badge expert-badge--silver ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Silver
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Gold":
      return (
        <div className={`expert-badge expert-badge--gold ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Gold
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Platinum":
      return (
        <div className={`expert-badge expert-badge--platinum ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Platinum
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Diamond":
      return (
        <div className={`expert-badge expert-badge--diamond ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Diamond
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Exclusive":
      return (
        <div className={`expert-badge expert-badge--exclusive ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Exclusive
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    case "Bronze":
      return (
        <div className={`expert-badge expert-badge--bronze ${className}`} onClick={openExpertBadgeInfoModal}>
          <Icon type={IconTypeEnum.Crown} viewBox={19} viewBoxHeight={16} className="expert-badge__icon-crown" />
          Bronze
          <Icon type={IconTypeEnum.ArrowRight} viewBox={10} viewBoxHeight={13} className="expert-badge__icon-arrow" />
        </div>
      );
    default:
      return (
        null
      );
  }
};

export default ExpertBadge;
